/*
 * FileUploader Messages
 *
 * This contains all the text for the FileUploader component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
    fileUpload: {
        id: 'app.components.FileUploader.fileUpload',
        defaultMessage: 'Upload file:'
    },
    browse: {
        id: 'app.components.FileUploader.browse',
        defaultMessage: 'Browse...'
    },
    upload: {
        id: 'app.components.FileUploader.upload',
        defaultMessage: 'Upload'
    },
    uploading: {
        id: 'app.components.components.uploading',
        defaultMessage: 'uploading'
    }
});



// WEBPACK FOOTER //
// ./app/components/file-uploader/messages.js